import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, userLocation} from '../Univ.js'
function LabInvoiceOp(props) {
    const {sale_lab} = useParams();
    const [labbillData, setLabBillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'lab-invoice-op/' + sale_lab)
                .then(function (response) {
                    setLabBillData(response.data);
                });
        } catch (error) {
            console.log(error);
        }
        try {
            axios.get(baseUrl + "view-hospital/" + userLocation + "/").then(function (response) {
                setHospData(response.data);
            });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    function numberToWords(num) {
        const units = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine'];
        const teens = ['eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
        const tens = ['', 'ten', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
        const scales = ['', 'thousand', 'million', 'billion', 'trillion', 'quadrillion', 'quintillion', 'sextillion', 'septillion', 'octillion', 'nonillion', 'decillion', 'undecillion', 'duodecillion', 'tredecillion', 'quattuordecillion', 'quindecillion', 'sexdecillion', 'septendecillion', 'octodecillion', 'novemdecillion', 'vigintillion'];
        function convertThreeDigitsLessThanThousand(num) {
            if (num === 0) return '';
            if (num < 10) return units[num];
            if (num < 20) return teens[num - 11];
            const onesDigit = num % 10;
            const tensDigit = Math.floor((num % 100) / 10);
            const hundredsDigit = Math.floor(num / 100);
            let result = '';
            if (hundredsDigit > 0) {
                result = `${units[hundredsDigit]} hundred`;
            }
            if (tensDigit > 0) {
                if (result) result += ' and ';
                if (tensDigit === 1) {
                    result += teens[onesDigit];
                } else if (onesDigit === 0) {
                    result += tens[tensDigit];
                } else {
                    result += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            } else if (onesDigit > 0) {
                if (result) result += ' and ';
                result += units[onesDigit];
            }
            return result;
        }
        function convertThreeDigits(num) {
            if (num === 0) return 'zero';
            if (num < 1000) return convertThreeDigitsLessThanThousand(num);
            let words = '';
            let scaleIndex = 0;
            while (num > 0) {
                const currentNum = num % 1000;
                if (currentNum !== 0) {
                    const currentWords = convertThreeDigitsLessThanThousand(currentNum);
                    if (scaleIndex > 0) {
                        words = `${currentWords} ${scales[scaleIndex]} ${words}`;
                    } else {
                        words = `${currentWords} ${words}`;
                    }
                }
                scaleIndex++;
                num = Math.floor(num / 1000);
            }
            return words.trim();
        }
        if (num === 10000) {
            return 'ten thousand rupees only';
        }
        if (num === 0) {
            return 'zero rupees only';
        }
        if (num < 0) return `negative ${numberToWords(Math.abs(num))}`;
        const parts = num.toString().split('.');
        let integerPart = parseInt(parts[0], 10);
        let decimalPart = parseInt(parts[1], 10) || 0;
        let words = '';
        let scaleIndex = 0;
        // Convert integer part
        while (integerPart > 0) {
            const hundreds = integerPart % 1000;
            if (hundreds !== 0) {
                const hundredsWords = convertThreeDigits(hundreds);
                if (scaleIndex !== 0) {
                    words = `${hundredsWords} ${scales[scaleIndex]} ${words}`;
                } else {
                    words = `${hundredsWords} ${words}`;
                }
            }
            scaleIndex++;
            integerPart = Math.floor(integerPart / 1000);
        }
        // Convert decimal part
        if (decimalPart > 0) {
            words += ' and ';
            if (decimalPart < 10) {
                words += units[decimalPart];
            } else if (decimalPart < 20) {
                words += teens[decimalPart - 11];
            } else {
                const onesDigit = decimalPart % 10;
                const tensDigit = Math.floor(decimalPart / 10);
                if (onesDigit === 0) {
                    words += tens[tensDigit];
                } else {
                    words += `${tens[tensDigit]}-${units[onesDigit]}`;
                }
            }
            words += ' paisa';
        }
        words += ' rupees only';
        return words.trim();
    }
    return (<section>
        <div>
            {labbillData.map((row, index) => <div id="invoice-print">

{/* =================================================
                HOSPITAL HEADER
            ================================================= */}

<div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>


{/* =================================================
                PATIENT / INVOICE DETAILS
            ================================================= */}

<div
    style={{
        width: "100%",
        margin: "8px 0 0 0",
        padding: "8px 12px",
        boxSizing: "border-box",
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        fontSize: "14px",
        lineHeight: "1.5"
    }}
>
    <div
        style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-start"
        }}
    >

        {/* =========================
                PATIENT DETAILS
            ========================= */}

        <div
            style={{
                width: "55%",
                paddingRight: "15px",
                boxSizing: "border-box",
                borderRight: "1px solid #999"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Name :</strong>&nbsp;
                {row.pat.patient}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>PID :</strong>&nbsp;
                {row.pat.pat_id}
            </div>

            <div>
                <strong>Consultant :</strong>&nbsp;
                Dr. {row.cons.consultant}
            </div>
        </div>


        {/* =========================
                INVOICE DETAILS
            ========================= */}

        <div
            style={{
                width: "45%",
                paddingLeft: "15px",
                boxSizing: "border-box"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Invoice No # :</strong>&nbsp;
                {row.lab_invoice}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Date :</strong>&nbsp;
                {row.lab_date}
            </div>

            <div>
                <strong>
                    {row.lab_pmode
                        ? row.lab_pmode.charAt(0).toUpperCase() +
                          row.lab_pmode.slice(1)
                        : ""} Receipt
                </strong>
            </div>
        </div>

    </div>
</div>

                <div>
                    <table border="2" rules="rows" cellpadding="3" className="text-justify mt-4" width="100%">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th align="left">S.No</th>
                            <th align="left">Particulars</th>
                            <th align="left">Amount</th>
                        </tr>
                        </thead>
                        <tbody>
                        {row.lab_test.split(',').map((test, subIndex) => (<tr key={`${index}-${subIndex}`}>
                            <td style={{
                                border: "1px solid", borderColor: "#2194d9"
                            }}>{index + subIndex + 1}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}><b><i
                                className="fa fa-inr" aria-hidden="true"></i>&nbsp;
                                {row.lab_amount.split(',')[subIndex].trim()}</b></td>
                        </tr>))}
                        <tr>
                            <td align="center"></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Invoiced
                                Amount</b></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.lab_tot}</b></td>
                        </tr>
                        {row.lab_disc != 0 && row.lab_disc != "" && (<tr>
                            <td align="center"></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Discount
                                Amount</b></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b style={{color: "red"}}><i className="fa fa-inr"
                                                             aria-hidden="true"></i>&nbsp;{row.lab_disc}</b>
                            </td>
                        </tr>)}
                        <tr>
                            <td align="center"></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Paid
                                Amount</b></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.lab_paid}</b></td>
                        </tr>
                        {row.lab_balance != 0 && row.lab_balance != "" && (<tr>
                            <td align="center"></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}><b>Balance
                                Amount</b></td>
                            <td align="left" style={{border: "1px solid", borderColor: "#2194d9"}}>
                                <b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.lab_balance}
                                </b></td>
                        </tr>)}
                        </tbody>
                    </table>
                    <p className="mt-2 p-3 text-bold">Received the sum
                        of {numberToWords(parseFloat(row.lab_paid))}.</p>
                    <div style={{display: 'flex', justifyContent: 'right', alignItems: 'right'}}>
                        <tr>
                            <th>{row.cashier}</th>
                            <br></br>
                            <th style={{width: "200px", borderTop: "2px solid black"}}>Cashier</th>
                        </tr>
                    </div>
                </div>
            </div>)}
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <button
                    style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                    onClick={handlePrint}
                >
                    Print
                </button>
            </div>
        </div>
    </section>);
}
export default LabInvoiceOp;